export const MAX_RATING_SCORE = 5;
export const MAX_RATINGS_COUNT = 1000;
